import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { useMemo, useState } from 'react';
import AccountTable from './AccountTable';
import { usePagination } from '../../hooks/usePagination';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ACCOUNTS_PER_PAGE = 5;
const useAccountSearch = accounts => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter accounts based on search term
  const filteredAccounts = useMemo(() => {
    // Sort accounts first by enabled, then pinned, then alphabetically
    const sortedAccounts = [...accounts].sort((a, b) => {
      var _a$accountName, _b$accountName;
      return Number(a.disabled) - Number(b.disabled) || Number(b.pinned) - Number(a.pinned) || (((_a$accountName = a.accountName) === null || _a$accountName === void 0 ? void 0 : _a$accountName.toLowerCase()) || '').localeCompare(((_b$accountName = b.accountName) === null || _b$accountName === void 0 ? void 0 : _b$accountName.toLowerCase()) || '');
    });
    if (!searchTerm.trim()) {
      return sortedAccounts;
    }
    const term = searchTerm.toLowerCase().trim();
    return sortedAccounts.filter(account => {
      var _account$accountName, _account$domain;
      return ((_account$accountName = account.accountName) === null || _account$accountName === void 0 ? void 0 : _account$accountName.toLowerCase().includes(term)) || ((_account$domain = account.domain) === null || _account$domain === void 0 ? void 0 : _account$domain.toLowerCase().includes(term)) || account.portalId.toString().includes(term);
    });
  }, [accounts, searchTerm]);
  return {
    searchTerm,
    filteredAccounts,
    setSearchTerm
  };
};
const AccountPicker = ({
  accounts,
  selectAccount,
  appName
}) => {
  const [selectedAccount, setSelectedAccount] = useState(null);
  const {
    filteredAccounts,
    setSearchTerm
  } = useAccountSearch(accounts);
  const {
    currentPage,
    totalPages,
    currentItems: visibleAccounts,
    goToPage
  } = usePagination({
    data: filteredAccounts,
    itemsPerPage: ACCOUNTS_PER_PAGE
  });
  const handleSearchChange = e => {
    setSearchTerm(e.target.value);
    goToPage(1);
    setSelectedAccount(null); // Clear selection on search
  };
  const handlePageChange = ({
    target: {
      value
    }
  }) => {
    goToPage(value);
  };
  const handleAccountSelect = account => {
    setSelectedAccount(account);
  };
  const handleConfirmButtonClick = () => {
    if (selectedAccount != null) {
      selectAccount(selectedAccount);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.header"
        })
      }), accounts.length > ACCOUNTS_PER_PAGE && /*#__PURE__*/_jsx(View, {
        inlineSize: "370px",
        children: /*#__PURE__*/_jsx(SearchInput, {
          placeholder: I18n.text('developer-experience-shared-components.accountPicker.searchPlaceholder'),
          onChange: handleSearchChange
        })
      })]
    }), /*#__PURE__*/_jsx(AccountTable, {
      accounts: visibleAccounts,
      selectedAccount: selectedAccount,
      setSelectedAccount: handleAccountSelect,
      appName: appName
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        disabled: !selectedAccount,
        onClick: handleConfirmButtonClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.chooseAccount"
        })
      }), filteredAccounts.length > ACCOUNTS_PER_PAGE && /*#__PURE__*/_jsx(View, {
        inlineSize: "275px",
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsx(Paginator, {
          onPageChange: handlePageChange,
          page: currentPage,
          pageCount: totalPages,
          maxVisiblePageButtons: 4
        })
      })]
    })]
  });
};
export default AccountPicker;